'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actionTypes = require('../../actions/action-types');

// Reducer cannot return undefined on initialization so we initialize with an invalid id
var NO_SHARE = 'NO_SHARE';

var sharingReducer = function sharingReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NO_SHARE;
  var action = arguments[1];

  switch (action.type) {
    case _actionTypes.SHARE_CONTENT:
      var feedContentId = action.feedContentId,
          notification = action.notification,
          showHighlightCta = action.showHighlightCta,
          title = action.title,
          isMiniProfile = action.isMiniProfile;

      return { feedContentId: feedContentId, notification: notification, showHighlightCta: showHighlightCta, title: title, isMiniProfile: isMiniProfile };
    default:
      return state;
  }
};

exports.default = sharingReducer;